export const FETCH_ALL_VIDEOS = "FETCH_ALL_VIDEOS";
export const FETCH_PENDING_VIDEOS = "FETCH_PENDING_VIDEOS";
export const FETCH_VIDEO = "FETCH_VIDEO";
export const UPLOAD_VIDEO = "UPLOAD_VIDEO";
export const UPDATE_VIDEO = "UPDATE_VIDEO";
export const DELETE_VIDEO = "DELETE_VIDEO";